/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Tracker_OosInputs */

const he_extension_tracker_oos = /** @type {(inputs: Extension_Tracker_OosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התראה עם PriceDrop כשיחזור למלאי`)
};

const en_extension_tracker_oos = /** @type {(inputs: Extension_Tracker_OosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alert when back in stock on PriceDrop`)
};

/**
* | output |
* | --- |
* | "Alert when back in stock on PriceDrop" |
*
* @param {Extension_Tracker_OosInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const extension_tracker_oos = /** @type {((inputs?: Extension_Tracker_OosInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Tracker_OosInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_tracker_oos(inputs)
	return en_extension_tracker_oos(inputs)
});